export interface ParsedItem {
  name: string;
  budgets: number[]; // length 12, integer kroner
  actuals: (number | null)[]; // length 12, integer kroner or null
}

export interface ParsedCategory {
  name: string;
  items: ParsedItem[];
}

export interface ParseResult {
  csvYear: number;
  categories: ParsedCategory[];
  warnings: string[];
}

export class ParseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ParseError';
  }
}
